/* eslint-disable no-console */
import { client } from "../../../../Utils/axiosClient";

export const rejectRentalRequest = async ({
  rentalId,
  reasonId,
  reasonText,
}) => {
  try {
    const response = await client.post(
      `${process.env.REACT_APP_API_URL}/rentals/reject-rental-request`,
      { rentalId, reasonId, reasonText },
    );

    if (response.status === 200) return { status: 200 };
    return { status: 500 };
  } catch (error) {
    console.log(error);
    return { status: 500 };
  }
};

// this will approve the request and put it in assign trike state (still not accepted)
export const approveRentalRequest = async ({ rentalId }) => {
  try {
    const response = await client.post(
      `${process.env.REACT_APP_API_URL}/rentals/approve-rental-request`,
      { rentalId },
    );

    if (response.status === 200) return { status: 200 };
    return { status: 500 };
  } catch (error) {
    console.log(error);
    return { status: 500 };
  }
};

export const assignAssets = async ({
  rentalId,
  trikeId,
  trikeRegistrationNo,
  batteries,
}) => {
  try {
    const response = await client.post(
      `${process.env.REACT_APP_API_URL}/rentals/assign-assets`,
      { rentalId, trikeId, trikeRegistrationNo, batteries },
    );

    if (response.status === 200) return { status: 200 };
    return { status: 500 };
  } catch (error) {
    console.log(error);
    return { status: 500 };
  }
};
